import React from 'react';
import type { CustomerStateType } from '../types/customer-states.types';

type CustomerStateBadgeProps = {
    state: {
        name?: string;
        type: CustomerStateType;
    };
};

export const TYPE_CONFIG: Record<CustomerStateType, { label: string; badgeClass: string }> = {
    INITIAL: {
        label: 'Inicial',
        badgeClass: 'badge bg-success-subtle text-success fs-12',
    },
    FINAL: {
        label: 'Final',
        badgeClass: 'badge bg-danger-subtle text-danger fs-12',
    },
    TRANSIENT: {
        label: 'Transitorio',
        badgeClass: 'badge bg-warning-subtle text-warning fs-12',
    },
};

export const CustomerStateBadge: React.FC<CustomerStateBadgeProps> = ({ state }) => {
    if (!state) return null;
    
    const config = TYPE_CONFIG[state.type] || {
        label: state.type,
        badgeClass: 'badge bg-secondary-subtle text-secondary fs-12',
    };

    return (
        <span className={config.badgeClass}>
            {state.name || config.label}
        </span>
    );
};

export default CustomerStateBadge;
